import {
  EMPTY_DATA,
  LOADER,
  GET_GSTR_OVERVIEW,
  GET_GSTR_OVERVIEW_ERROR,
  GET_GSTR_OVERVIEW_EMPTY,
  GET_AGGREGATE_GSTR_OVERVIEW,
  GET_AGGREGATE_GSTR_OVERVIEW_ERROR,
  GET_AGGREGATE_GSTR_OVERVIEW_EMPTY,
  GET_SALES_SUMMARY,
  GET_SALES_SUMMARY_ERROR,
  GET_SALES_SUMMARY_EMPTY,
  GET_AGGREGATE_SALES_SUMMARY,
  GET_AGGREGATE_SALES_SUMMARY_ERROR,
  GET_AGGREGATE_SALES_SUMMARY_EMPTY,
  SET_SALES_SUMMARY_PERSIST,
  GET_SALES_STATE,
  GET_SALES_STATE_ERROR,
  GET_SALES_STATE_EMPTY,
  GET_AGGREGATE_SALES_STATE,
  GET_AGGREGATE_SALES_STATE_ERROR,
  GET_AGGREGATE_SALES_STATE_EMPTY,
  SET_SALES_STATE_PERSIST,
  GET_SALES_CATEGORY,
  GET_SALES_CATEGORY_ERROR,
  GET_SALES_CATEGORY_EMPTY,
  GET_AGGREGATE_SALES_CATEGORY,
  GET_AGGREGATE_SALES_CATEGORY_ERROR,
  GET_AGGREGATE_SALES_CATEGORY_EMPTY,
  SET_SALES_CATEGORY_PERSIST,
  GET_SALES_CUSTOMER,
  GET_SALES_CUSTOMER_ERROR,
  GET_SALES_CUSTOMER_EMPTY,
  GET_AGGREGATE_SALES_CUSTOMER,
  GET_AGGREGATE_SALES_CUSTOMER_ERROR,
  GET_AGGREGATE_SALES_CUSTOMER_EMPTY,
  SET_SALES_CUSTOMER_PERSIST,
  GET_SALES_HSNSUMMARY,
  GET_SALES_HSNSUMMARY_ERROR,
  GET_SALES_HSNSUMMARY_EMPTY,
  GET_AGGREGATE_SALES_HSNSUMMARY,
  GET_AGGREGATE_SALES_HSNSUMMARY_ERROR,
  GET_AGGREGATE_SALES_HSNSUMMARY_EMPTY,
  SET_SALES_HSNSUMMARY_PERSIST,
  GET_SALES_INTRAORGANIZATION,
  GET_SALES_INTRAORGANIZATION_ERROR,
  GET_SALES_INTRAORGANIZATION_EMPTY,
  GET_AGGREGATE_SALES_INTRAORGANIZATION,
  GET_AGGREGATE_SALES_INTRAORGANIZATION_ERROR,
  GET_AGGREGATE_SALES_INTRAORGANIZATION_EMPTY,
  SET_SALES_INTRAORGANIZATION_PERSIST,
  GET_PURCHASES_SUMMARY,
  GET_PURCHASES_SUMMARY_ERROR,
  GET_PURCHASES_SUMMARY_EMPTY,
  GET_AGGREGATE_PURCHASES_SUMMARY,
  GET_AGGREGATE_PURCHASES_SUMMARY_ERROR,
  GET_AGGREGATE_PURCHASES_SUMMARY_EMPTY,
  SET_PURCHASES_SUMMARY_PERSIST,
  GET_PURCHASES_STATE,
  GET_PURCHASES_STATE_ERROR,
  GET_PURCHASES_STATE_EMPTY,
  GET_AGGREGATE_PURCHASES_STATE,
  GET_AGGREGATE_PURCHASES_STATE_ERROR,
  GET_AGGREGATE_PURCHASES_STATE_EMPTY,
  SET_PURCHASES_STATE_PERSIST,
  GET_PURCHASES_CATEGORY,
  GET_PURCHASES_CATEGORY_ERROR,
  GET_PURCHASES_CATEGORY_EMPTY,
  GET_AGGREGATE_PURCHASES_CATEGORY,
  GET_AGGREGATE_PURCHASES_CATEGORY_ERROR,
  GET_AGGREGATE_PURCHASES_CATEGORY_EMPTY,
  SET_PURCHASES_CATEGORY_PERSIST,
  GET_PURCHASES_SUPPLIERS,
  GET_PURCHASES_SUPPLIERS_ERROR,
  GET_PURCHASES_SUPPLIERS_EMPTY,
  GET_AGGREGATE_PURCHASES_SUPPLIERS,
  GET_AGGREGATE_PURCHASES_SUPPLIERS_ERROR,
  GET_AGGREGATE_PURCHASES_SUPPLIERS_EMPTY,
  SET_PURCHASES_SUPPLIERS_PERSIST,
  GET_PURCHASES_INTRAORGANIZATION,
  GET_PURCHASES_INTRAORGANIZATION_ERROR,
  GET_PURCHASES_INTRAORGANIZATION_EMPTY,
  GET_AGGREGATE_PURCHASES_INTRAORGANIZATION,
  GET_AGGREGATE_PURCHASES_INTRAORGANIZATION_ERROR,
  GET_AGGREGATE_PURCHASES_INTRAORGANIZATION_EMPTY,
  SET_PURCHASES_INTRAORGANIZATION_PERSIST,
  GET_CYCLICTXN,
  GET_CYCLICTXN_ERROR,
  GET_CYCLICTXN_EMPTY,
  GET_AGGREGATE_CYCLICTXN,
  GET_AGGREGATE_CYCLICTXN_ERROR,
  GET_AGGREGATE_CYCLICTXN_EMPTY,
  SET_CYCLICTXN_PERSIST,
  GET_NOTES,
  GET_NOTES_ERROR,
  GET_NOTES_EMPTY,
  GET_AGGREGATE_NOTES,
  GET_AGGREGATE_NOTES_ERROR,
  GET_AGGREGATE_NOTES_EMPTY,
  SET_NOTES_PERSIST,
  GET_TAXLIABILITY,
  GET_TAXLIABILITY_ERROR,
  GET_TAXLIABILITY_EMPTY,
  GET_AGGREGATE_TAXLIABILITY,
  GET_AGGREGATE_TAXLIABILITY_ERROR,
  GET_AGGREGATE_TAXLIABILITY_EMPTY,
  SET_TAXLIABILITY_PERSIST,
  GET_INPUT_TAXCREDIT,
  GET_INPUT_TAXCREDIT_ERROR,
  GET_INPUT_TAXCREDIT_EMPTY,
  GET_AGGREGATE_INPUT_TAXCREDIT,
  GET_AGGREGATE_INPUT_TAXCREDIT_ERROR,
  GET_AGGREGATE_INPUT_TAXCREDIT_EMPTY,
  SET_INPUT_TAXCREDIT_PERSIST,
  GET_FILINGSTATUS,
  GET_FILINGSTATUS_ERROR,
  GET_FILINGSTATUS_EMPTY,
  SET_FILINGSTATUS_PERSIST,
  SET_SUBTABS_PERSIST,
  GET_SALES_CUSTOMER_BY_MONTH,
  GET_SALES_CUSTOMER_BY_MONTH_ERROR,
  GET_SALES_CUSTOMER_BY_MONTH_EMPTY,
  GET_PURCHASES_SUPPLIERS_BY_MONTH,
  GET_PURCHASES_SUPPLIERS_BY_MONTH_ERROR,
  GET_PURCHASES_SUPPLIERS_BY_MONTH_EMPTY
} from 'src/actions/gstrAnalysisActions';
import produce from 'immer';

const salesSummaryPersistInitialValue = {
  orderBy: 'month',
  order: 'desc',
  filterValue: 'Show All',
  page: 0,
  rowsPerPage: 25
};

const salesStatePersistInitialValue = {
  orderBy: 'gstr1InvoiceValue',
  order: 'desc',
  filterValue: 'Show All',
  page: 0,
  rowsPerPage: 20
};

const salesCategoryPersistInitialValue = {
  filterValue: 'Show All',
  INVOICES: { open: true, orderBy: 'gstr1InvoiceValue', order: 'desc' },
  'AMENDED INVOICES': {
    open: false,
    orderBy: 'gstr1InvoiceValue',
    order: 'desc'
  },
  'ADVANCES RECEIVED/ TAX LIABILITY': {
    open: false,
    orderBy: '',
    order: 'desc'
  },
  'AMENDED ADVANCES RECEIVED/ TAX LIABILITY': {
    open: false,
    orderBy: '',
    order: 'desc'
  }
};

const salesCustomerPersistInitialValue = {
  orderBy: 'invoiceValue',
  order: 'desc',
  filterValue: 'Show All',
  page: 0,
  rowsPerPage: 20
};

const salesHsnSummaryPersistInitialValue = {
  orderBy: 'invoiceValue',
  order: 'desc',
  filterValue: 'Show All',
  page: 0,
  rowsPerPage: 20
};

const salesIntraOrganizationPersistInitialValue = {
  orderBy: 'month',
  order: 'desc',
  filterValue: 'Show All',
  page: 0,
  rowsPerPage: 20
};

const purchasesSummaryPersistInitialValue = {
  orderBy: 'month',
  order: 'desc',
  filterValue: 'Show All',
  page: 0,
  rowsPerPage: 25
};

const purchasesStatePersistInitialValue = {
  orderBy: 'gstr2aInvoiceValue',
  order: 'desc',
  filterValue: 'Show All',
  page: 0,
  rowsPerPage: 20
};

const purchasesCategoryPersistInitialValue = {
  filterValue: 'Show All',
  INVOICES: { open: true, orderBy: 'gstr2aInvoiceValue', order: 'desc' },
  'AMENDED INVOICES': {
    open: false,
    orderBy: 'gstr2aInvoiceValue',
    order: 'desc'
  }
};

const purchasesSuppliersPersistInitialValue = {
  orderBy: 'invoiceValue',
  order: 'desc',
  filterValue: 'Show All',
  page: 0,
  rowsPerPage: 20
};

const purchasesIntraOrganizationPersistInitialValue = {
  orderBy: 'month',
  order: 'desc',
  filterValue: 'Show All',
  page: 0,
  rowsPerPage: 20
};

const cyclicTxnPersistInitialValue = {
  orderBy: 'salesValue',
  order: 'desc',
  filterValue: 'Show All',
  page: 0,
  rowsPerPage: 20
};

const notesPersistInitialValue = {
  filterValue: 'Show All',
  'CREDIT/ DEBIT NOTES (REGISTERED)': {
    open: false,
    orderBy: '',
    order: 'desc'
  },
  'CREDIT/ DEBIT NOTES (UNREGISTERED)': {
    open: false,
    orderBy: '',
    order: 'desc'
  },
  'AMENDED CREDIT/ DEBIT NOTES': {
    open: false,
    orderBy: 'taxableValue',
    order: 'desc'
  }
};

const taxliabilityPersistInitialValue = {
  orderBy: 'month',
  order: 'desc',
  filterValue: 'Show All',
  page: 0,
  rowsPerPage: 20
};

const inputTaxCreditPersistInitialValue = {
  orderBy: 'month',
  order: 'desc',
  filterValue: 'Show All',
  page: 0,
  rowsPerPage: 20
};

const filingStatusPersistInitialValue = {
  orderBy: 'month',
  order: 'desc',
  filterValue: 'Show All',
  page: 0,
  rowsPerPage: 12
};

const subTabsPersistInitialValue = {
  sales: 'salesSummary',
  purchases: 'purchasesSummary'
};

const initialState = {
  isLoading: false,
  aggregateGstrOverview: null,
  aggregateGstrOverviewError: null,
  gstrOverview: null,
  gstrOverviewError: null,
  salesSummary: null,
  salesSummaryError: null,
  aggregateSalesSummary: null,
  aggregateSalesSummaryError: null,
  salesSummaryPersist: salesSummaryPersistInitialValue,
  salesState: null,
  salesStateError: null,
  aggregateSalesState: null,
  aggregateSalesStateError: null,
  salesStatePersist: salesStatePersistInitialValue,
  salesCategory: null,
  salesCategoryError: null,
  aggregateSalesCategory: null,
  aggregateSalesCategoryError: null,
  salesCategoryPersist: salesCategoryPersistInitialValue,
  salesCustomer: null,
  salesCustomerError: null,
  aggregateSalesCustomer: null,
  aggregateSalesCustomerError: null,
  salesCustomerPersist: salesCustomerPersistInitialValue,
  salesHsnSummary: null,
  salesHsnSummaryError: null,
  aggregateSalesHsnSummary: null,
  aggregateSalesHsnSummaryError: null,
  salesHsnSummaryPersist: salesHsnSummaryPersistInitialValue,
  salesIntraOrganization: null,
  salesIntraOrganizationError: null,
  aggregateSalesIntraOrganization: null,
  aggregateSalesIntraOrganizationError: null,
  salesIntraOrganizationPersist: salesIntraOrganizationPersistInitialValue,
  purchasesSummary: null,
  purchasesSummaryError: null,
  aggregatePurchasesSummary: null,
  aggregatePurchasesSummaryError: null,
  purchasesSummaryPersist: purchasesSummaryPersistInitialValue,
  purchasesState: null,
  purchasesStateError: null,
  aggregatePurchasesState: null,
  aggregatePurchasesStateError: null,
  purchasesStatePersist: purchasesStatePersistInitialValue,
  purchasesCategory: null,
  purchasesCategoryError: null,
  aggregatePurchasesCategory: null,
  aggregatePurchasesCategoryError: null,
  purchasesCategoryPersist: purchasesCategoryPersistInitialValue,
  purchasesSuppliers: null,
  purchasesSuppliersError: null,
  aggregatePurchasesSuppliers: null,
  aggregatePurchasesSuppliersError: null,
  purchasesSuppliersPersist: purchasesSuppliersPersistInitialValue,
  purchasesIntraOrganization: null,
  purchasesIntraOrganizationError: null,
  aggregatePurchasesIntraOrganization: null,
  aggregatePurchasesIntraOrganizationError: null,
  purchasesIntraOrganizationPersist: purchasesIntraOrganizationPersistInitialValue,
  cyclicTxn: null,
  cyclicTxnError: null,
  aggregateCyclicTxn: null,
  aggregateCyclicTxnError: null,
  cyclicTxnPersist: cyclicTxnPersistInitialValue,
  notes: null,
  notesError: null,
  aggregateNotes: null,
  aggregateNotesError: null,
  notesPersist: notesPersistInitialValue,
  taxliability: null,
  taxliabilityError: null,
  aggregateTaxliability: null,
  aggregateTaxliabilityError: null,
  taxliabilityPersist: taxliabilityPersistInitialValue,
  inputTaxCredit: null,
  inputTaxCreditError: null,
  aggregateInputTaxCredit: null,
  aggregateInputTaxCreditError: null,
  inputTaxCreditPersist: inputTaxCreditPersistInitialValue,
  filingStatus: null,
  filingStatusError: null,
  aggregateFilingStatus: null,
  aggregateFilingStatusError: null,
  filingStatusPersist: filingStatusPersistInitialValue,
  subTabsPersist: subTabsPersistInitialValue,
  salesCustomerByMonth: null,
  salesCustomerByMonthError: null,
  purchasesSuppliersByMonth: null,
  purchasesSuppliersByMonthError: null
};

const gstrAnalysisReducer = (state = initialState, action) => {
  switch (action.type) {
    case EMPTY_DATA: {
      return produce(state, draft => {
        draft.aggregateGstrOverview = null;
        draft.aggregateGstrOverviewError = null;
        draft.gstrOverview = null;
        draft.gstrOverviewError = null;
        draft.salesSummary = null;
        draft.salesSummaryError = null;
        draft.aggregateSalesSummary = null;
        draft.aggregateSalesSummaryError = null;
        draft.salesState = null;
        draft.salesStateError = null;
        draft.salesCategory = null;
        draft.salesCategoryError = null;
        draft.salesCustomer = null;
        draft.salesCustomerError = null;
        draft.salesHsnSummary = null;
        draft.salesHsnSummaryError = null;
        draft.salesIntraOrganization = null;
        draft.salesIntraOrganizationError = null;
        draft.purchasesSummary = null;
        draft.purchasesSummaryError = null;
        draft.purchasesState = null;
        draft.purchasesStateError = null;
        draft.purchasesCategory = null;
        draft.purchasesCategoryError = null;
        draft.purchasesSuppliers = null;
        draft.purchasesSuppliersError = null;
        draft.purchasesIntraOrganization = null;
        draft.purchasesIntraOrganizationError = null;
        draft.cyclicTxn = null;
        draft.cyclicTxnError = null;
        draft.notes = null;
        draft.notesError = null;
        draft.taxliability = null;
        draft.taxliabilityError = null;
        draft.inputTaxCredit = null;
        draft.inputTaxCreditError = null;
        draft.filingStatus = null;
        draft.filingStatusError = null;
        draft.aggregateSalesState = null;
        draft.aggregateSalesStateError = null;
        draft.aggregateSalesCategory = null;
        draft.aggregateSalesCategoryError = null;
        draft.aggregateSalesCustomer = null;
        draft.aggregateSalesCustomerError = null;
        draft.aggregateSalesHsnSummary = null;
        draft.aggregateSalesHsnSummaryError = null;
        draft.aggregateSalesIntraOrganization = null;
        draft.aggregateSalesIntraOrganizationError = null;
        draft.aggregatePurchasesSummary = null;
        draft.aggregatePurchasesSummaryError = null;
        draft.aggregatePurchasesState = null;
        draft.aggregatePurchasesStateError = null;
        draft.aggregatePurchasesCategory = null;
        draft.aggregatePurchasesCategoryError = null;
        draft.aggregatePurchasesSuppliers = null;
        draft.aggregatePurchasesSuppliersError = null;
        draft.aggregatePurchasesIntraOrganization = null;
        draft.aggregatePurchasesIntraOrganizationError = null;
        draft.aggregateCyclicTxn = null;
        draft.aggregateCyclicTxnError = null;
        draft.aggregateNotes = null;
        draft.aggregateNotesError = null;
        draft.aggregateTaxliability = null;
        draft.aggregateTaxliabilityError = null;
        draft.aggregateInputTaxCreditError = null;
        draft.aggregateInputTaxCreditError = null;
        draft.salesCustomerByMonth = null;
        draft.salesCustomerByMonthError = null;
        draft.purchasesSuppliersByMonth = null;
        draft.purchasesSuppliersByMonthError = null;
      });
    }

    case LOADER: {
      return produce(state, draft => {
        draft.isLoading = true;
      });
    }

    case GET_GSTR_OVERVIEW: {
      return produce(state, draft => {
        draft.gstrOverview = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_GSTR_OVERVIEW_ERROR: {
      return produce(state, draft => {
        draft.gstrOverviewError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_GSTR_OVERVIEW_EMPTY: {
      return produce(state, draft => {
        draft.gstrOverviewError = null;
        draft.gstrOverview = null;
      });
    }

    case GET_AGGREGATE_GSTR_OVERVIEW: {
      return produce(state, draft => {
        draft.aggregateGstrOverview = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_GSTR_OVERVIEW_ERROR: {
      return produce(state, draft => {
        draft.aggregateGstrOverviewError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_GSTR_OVERVIEW_EMPTY: {
      return produce(state, draft => {
        draft.aggregateGstrOverviewError = null;
        draft.aggregateGstrOverview = null;
      });
    }

    case GET_SALES_SUMMARY: {
      return produce(state, draft => {
        draft.salesSummary = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_SALES_SUMMARY_ERROR: {
      return produce(state, draft => {
        draft.salesSummaryError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_SALES_SUMMARY_EMPTY: {
      return produce(state, draft => {
        draft.salesSummaryError = null;
        draft.salesSummary = null;
      });
    }

    case GET_AGGREGATE_SALES_SUMMARY: {
      return produce(state, draft => {
        draft.aggregateSalesSummary = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_SALES_SUMMARY_ERROR: {
      return produce(state, draft => {
        draft.aggregateSalesSummaryError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_SALES_SUMMARY_EMPTY: {
      return produce(state, draft => {
        draft.aggregateSalesSummaryError = null;
        draft.aggregateSalesSummary = null;
      });
    }

    case SET_SALES_SUMMARY_PERSIST: {
      return produce(state, draft => {
        draft.salesSummaryPersist = action.payload;
      });
    }

    case GET_SALES_STATE: {
      return produce(state, draft => {
        draft.salesState = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_SALES_STATE_ERROR: {
      return produce(state, draft => {
        draft.salesStateError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_SALES_STATE_EMPTY: {
      return produce(state, draft => {
        draft.salesStateError = null;
        draft.salesState = null;
      });
    }

    case GET_AGGREGATE_SALES_STATE: {
      return produce(state, draft => {
        draft.aggregateSalesState = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_SALES_STATE_ERROR: {
      return produce(state, draft => {
        draft.aggregateSalesStateError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_SALES_STATE_EMPTY: {
      return produce(state, draft => {
        draft.aggregateSalesStateError = null;
        draft.aggregateSalesState = null;
      });
    }

    case SET_SALES_STATE_PERSIST: {
      return produce(state, draft => {
        draft.salesStatePersist = action.payload;
      });
    }

    case GET_SALES_CATEGORY: {
      return produce(state, draft => {
        draft.salesCategory = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_SALES_CATEGORY_ERROR: {
      return produce(state, draft => {
        draft.salesCategoryError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_SALES_CATEGORY_EMPTY: {
      return produce(state, draft => {
        draft.salesCategoryError = null;
        draft.salesCategory = null;
      });
    }

    case GET_AGGREGATE_SALES_CATEGORY: {
      return produce(state, draft => {
        draft.aggregateSalesCategory = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_SALES_CATEGORY_ERROR: {
      return produce(state, draft => {
        draft.aggregateSalesCategoryError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_SALES_CATEGORY_EMPTY: {
      return produce(state, draft => {
        draft.aggregateSalesCategoryError = null;
        draft.aggregateSalesCategory = null;
      });
    }

    case SET_SALES_CATEGORY_PERSIST: {
      return produce(state, draft => {
        draft.salesCategoryPersist = action.payload;
      });
    }

    case GET_SALES_CUSTOMER: {
      return produce(state, draft => {
        draft.salesCustomer = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_SALES_CUSTOMER_ERROR: {
      return produce(state, draft => {
        draft.salesCustomerError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_SALES_CUSTOMER_EMPTY: {
      return produce(state, draft => {
        draft.salesCustomerError = null;
        draft.salesCustomer = null;
      });
    }

    case GET_AGGREGATE_SALES_CUSTOMER: {
      return produce(state, draft => {
        draft.aggregateSalesCustomer = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_SALES_CUSTOMER_ERROR: {
      return produce(state, draft => {
        draft.aggregateSalesCustomerError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_SALES_CUSTOMER_EMPTY: {
      return produce(state, draft => {
        draft.aggregateSalesCustomerError = null;
        draft.aggregateSalesCustomer = null;
      });
    }

    case SET_SALES_CUSTOMER_PERSIST: {
      return produce(state, draft => {
        draft.salesCustomerPersist = action.payload;
      });
    }

    case GET_SALES_HSNSUMMARY: {
      return produce(state, draft => {
        draft.salesHsnSummary = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_SALES_HSNSUMMARY_ERROR: {
      return produce(state, draft => {
        draft.salesHsnSummaryError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_SALES_HSNSUMMARY_EMPTY: {
      return produce(state, draft => {
        draft.salesHsnSummaryError = null;
        draft.salesHsnSummary = null;
      });
    }

    case GET_AGGREGATE_SALES_HSNSUMMARY: {
      return produce(state, draft => {
        draft.aggregateSalesHsnSummary = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_SALES_HSNSUMMARY_ERROR: {
      return produce(state, draft => {
        draft.aggregateSalesHsnSummaryError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_SALES_HSNSUMMARY_EMPTY: {
      return produce(state, draft => {
        draft.aggregateSalesHsnSummaryError = null;
        draft.aggregateSalesHsnSummary = null;
      });
    }

    case SET_SALES_HSNSUMMARY_PERSIST: {
      return produce(state, draft => {
        draft.salesHsnSummaryPersist = action.payload;
      });
    }

    case GET_SALES_INTRAORGANIZATION: {
      return produce(state, draft => {
        draft.salesIntraOrganization = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_SALES_INTRAORGANIZATION_ERROR: {
      return produce(state, draft => {
        draft.salesIntraOrganizationError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_SALES_INTRAORGANIZATION_EMPTY: {
      return produce(state, draft => {
        draft.salesIntraOrganizationError = null;
        draft.salesIntraOrganization = null;
      });
    }

    case GET_AGGREGATE_SALES_INTRAORGANIZATION: {
      return produce(state, draft => {
        draft.aggregateSalesIntraOrganization = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_SALES_INTRAORGANIZATION_ERROR: {
      return produce(state, draft => {
        draft.aggregateSalesIntraOrganizationError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_SALES_INTRAORGANIZATION_EMPTY: {
      return produce(state, draft => {
        draft.aggregateSalesIntraOrganizationError = null;
        draft.aggregateSalesIntraOrganization = null;
      });
    }

    case SET_SALES_INTRAORGANIZATION_PERSIST: {
      return produce(state, draft => {
        draft.salesIntraOrganizationPersist = action.payload;
      });
    }

    case GET_PURCHASES_SUMMARY: {
      return produce(state, draft => {
        draft.purchasesSummary = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_PURCHASES_SUMMARY_ERROR: {
      return produce(state, draft => {
        draft.purchasesSummaryError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_PURCHASES_SUMMARY_EMPTY: {
      return produce(state, draft => {
        draft.purchasesSummaryError = null;
        draft.purchasesSummary = null;
      });
    }

    case GET_AGGREGATE_PURCHASES_SUMMARY: {
      return produce(state, draft => {
        draft.aggregatePurchasesSummary = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_PURCHASES_SUMMARY_ERROR: {
      return produce(state, draft => {
        draft.aggregatePurchasesSummaryError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_PURCHASES_SUMMARY_EMPTY: {
      return produce(state, draft => {
        draft.aggregatePurchasesSummaryError = null;
        draft.aggregatePurchasesSummary = null;
      });
    }

    case SET_PURCHASES_SUMMARY_PERSIST: {
      return produce(state, draft => {
        draft.purchasesSummaryPersist = action.payload;
      });
    }

    case GET_PURCHASES_STATE: {
      return produce(state, draft => {
        draft.purchasesState = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_PURCHASES_STATE_ERROR: {
      return produce(state, draft => {
        draft.purchasesStateError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_PURCHASES_STATE_EMPTY: {
      return produce(state, draft => {
        draft.purchasesStateError = null;
        draft.purchasesState = null;
      });
    }

    case GET_AGGREGATE_PURCHASES_STATE: {
      return produce(state, draft => {
        draft.aggregatePurchasesState = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_PURCHASES_STATE_ERROR: {
      return produce(state, draft => {
        draft.aggregatePurchasesStateError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_PURCHASES_STATE_EMPTY: {
      return produce(state, draft => {
        draft.aggregatePurchasesStateError = null;
        draft.aggregatePurchasesState = null;
      });
    }

    case SET_PURCHASES_STATE_PERSIST: {
      return produce(state, draft => {
        draft.purchasesStatePersist = action.payload;
      });
    }

    case GET_PURCHASES_CATEGORY: {
      return produce(state, draft => {
        draft.purchasesCategory = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_PURCHASES_CATEGORY_ERROR: {
      return produce(state, draft => {
        draft.purchasesCategoryError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_PURCHASES_CATEGORY_EMPTY: {
      return produce(state, draft => {
        draft.purchasesCategoryError = null;
        draft.purchasesCategory = null;
      });
    }

    case GET_AGGREGATE_PURCHASES_CATEGORY: {
      return produce(state, draft => {
        draft.aggregatePurchasesCategory = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_PURCHASES_CATEGORY_ERROR: {
      return produce(state, draft => {
        draft.aggregatePurchasesCategoryError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_PURCHASES_CATEGORY_EMPTY: {
      return produce(state, draft => {
        draft.aggregatePurchasesCategoryError = null;
        draft.aggregatePurchasesCategory = null;
      });
    }

    case SET_PURCHASES_CATEGORY_PERSIST: {
      return produce(state, draft => {
        draft.purchasesCategoryPersist = action.payload;
      });
    }

    case GET_PURCHASES_SUPPLIERS: {
      return produce(state, draft => {
        draft.purchasesSuppliers = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_PURCHASES_SUPPLIERS_ERROR: {
      return produce(state, draft => {
        draft.purchasesSuppliersError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_PURCHASES_SUPPLIERS_EMPTY: {
      return produce(state, draft => {
        draft.purchasesSuppliersError = null;
        draft.purchasesSuppliers = null;
      });
    }

    case GET_AGGREGATE_PURCHASES_SUPPLIERS: {
      return produce(state, draft => {
        draft.aggregatePurchasesSuppliers = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_PURCHASES_SUPPLIERS_ERROR: {
      return produce(state, draft => {
        draft.aggregatePurchasesSuppliersError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_PURCHASES_SUPPLIERS_EMPTY: {
      return produce(state, draft => {
        draft.aggregatePurchasesSuppliersError = null;
        draft.aggregatePurchasesSuppliers = null;
      });
    }

    case SET_PURCHASES_SUPPLIERS_PERSIST: {
      return produce(state, draft => {
        draft.purchasesSuppliersPersist = action.payload;
      });
    }

    case GET_PURCHASES_INTRAORGANIZATION: {
      return produce(state, draft => {
        draft.purchasesIntraOrganization = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_PURCHASES_INTRAORGANIZATION_ERROR: {
      return produce(state, draft => {
        draft.purchasesIntraOrganizationError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_PURCHASES_INTRAORGANIZATION_EMPTY: {
      return produce(state, draft => {
        draft.purchasesIntraOrganizationError = null;
        draft.purchasesIntraOrganization = null;
      });
    }

    case GET_AGGREGATE_PURCHASES_INTRAORGANIZATION: {
      return produce(state, draft => {
        draft.aggregatePurchasesIntraOrganization = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_PURCHASES_INTRAORGANIZATION_ERROR: {
      return produce(state, draft => {
        draft.aggregatePurchasesIntraOrganizationError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_PURCHASES_INTRAORGANIZATION_EMPTY: {
      return produce(state, draft => {
        draft.aggregatePurchasesIntraOrganizationError = null;
        draft.aggregatePurchasesIntraOrganization = null;
      });
    }

    case SET_PURCHASES_INTRAORGANIZATION_PERSIST: {
      return produce(state, draft => {
        draft.purchasesIntraOrganizationPersist = action.payload;
      });
    }

    case GET_CYCLICTXN: {
      return produce(state, draft => {
        draft.cyclicTxn = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_CYCLICTXN_ERROR: {
      return produce(state, draft => {
        draft.cyclicTxnError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_CYCLICTXN_EMPTY: {
      return produce(state, draft => {
        draft.cyclicTxnError = null;
        draft.cyclicTxn = null;
      });
    }

    case GET_AGGREGATE_CYCLICTXN: {
      return produce(state, draft => {
        draft.aggregateCyclicTxn = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_CYCLICTXN_ERROR: {
      return produce(state, draft => {
        draft.aggregateCyclicTxnError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_CYCLICTXN_EMPTY: {
      return produce(state, draft => {
        draft.aggregateCyclicTxnError = null;
        draft.aggregateCyclicTxn = null;
      });
    }

    case SET_CYCLICTXN_PERSIST: {
      return produce(state, draft => {
        draft.cyclicTxnPersist = action.payload;
      });
    }

    case GET_NOTES: {
      return produce(state, draft => {
        draft.notes = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_NOTES_ERROR: {
      return produce(state, draft => {
        draft.notesError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_NOTES_EMPTY: {
      return produce(state, draft => {
        draft.notesError = null;
        draft.notes = null;
      });
    }

    case GET_AGGREGATE_NOTES: {
      return produce(state, draft => {
        draft.aggregateNotes = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_NOTES_ERROR: {
      return produce(state, draft => {
        draft.aggregateNotesError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_NOTES_EMPTY: {
      return produce(state, draft => {
        draft.aggregateNotesError = null;
        draft.aggregateNotes = null;
      });
    }

    case SET_NOTES_PERSIST: {
      return produce(state, draft => {
        draft.notesPersist = action.payload;
      });
    }

    case GET_TAXLIABILITY: {
      return produce(state, draft => {
        draft.taxliability = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_TAXLIABILITY_ERROR: {
      return produce(state, draft => {
        draft.taxliabilityError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_TAXLIABILITY_EMPTY: {
      return produce(state, draft => {
        draft.taxliabilityError = null;
        draft.taxliability = null;
      });
    }

    case GET_AGGREGATE_TAXLIABILITY: {
      return produce(state, draft => {
        draft.aggregateTaxliability = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_TAXLIABILITY_ERROR: {
      return produce(state, draft => {
        draft.aggregateTaxliabilityError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_TAXLIABILITY_EMPTY: {
      return produce(state, draft => {
        draft.aggregateTaxliabilityError = null;
        draft.aggregateTaxliability = null;
      });
    }

    case SET_TAXLIABILITY_PERSIST: {
      return produce(state, draft => {
        draft.taxliabilityPersist = action.payload;
      });
    }

    case GET_INPUT_TAXCREDIT: {
      return produce(state, draft => {
        draft.inputTaxCredit = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_INPUT_TAXCREDIT_ERROR: {
      return produce(state, draft => {
        draft.inputTaxCreditError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_INPUT_TAXCREDIT_EMPTY: {
      return produce(state, draft => {
        draft.inputTaxCreditError = null;
        draft.inputTaxCredit = null;
      });
    }

    case GET_AGGREGATE_INPUT_TAXCREDIT: {
      return produce(state, draft => {
        draft.aggregateInputTaxCredit = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_INPUT_TAXCREDIT_ERROR: {
      return produce(state, draft => {
        draft.aggregateInputTaxCreditError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_AGGREGATE_INPUT_TAXCREDIT_EMPTY: {
      return produce(state, draft => {
        draft.aggregateInputTaxCreditError = null;
        draft.aggregateInputTaxCredit = null;
      });
    }

    case SET_INPUT_TAXCREDIT_PERSIST: {
      return produce(state, draft => {
        draft.inputTaxCreditPersist = action.payload;
      });
    }

    case GET_FILINGSTATUS: {
      return produce(state, draft => {
        draft.filingStatus = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_FILINGSTATUS_ERROR: {
      return produce(state, draft => {
        draft.filingStatusError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_FILINGSTATUS_EMPTY: {
      return produce(state, draft => {
        draft.filingStatusError = null;
        draft.filingStatus = null;
      });
    }

    case SET_FILINGSTATUS_PERSIST: {
      return produce(state, draft => {
        draft.filingStatusPersist = action.payload;
      });
    }

    case SET_SUBTABS_PERSIST: {
      return produce(state, draft => {
        draft.subTabsPersist = action.payload;
      });
    }

    case GET_SALES_CUSTOMER_BY_MONTH: {
      return produce(state, draft => {
        draft.salesCustomerByMonth = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_SALES_CUSTOMER_BY_MONTH_ERROR: {
      return produce(state, draft => {
        draft.salesCustomerByMonthError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_SALES_CUSTOMER_BY_MONTH_EMPTY: {
      return produce(state, draft => {
        draft.salesCustomerByMonth = null;
        draft.salesCustomer = null;
      });
    }

    case GET_PURCHASES_SUPPLIERS_BY_MONTH: {
      return produce(state, draft => {
        draft.purchasesSuppliersByMonth = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_PURCHASES_SUPPLIERS_BY_MONTH_ERROR: {
      return produce(state, draft => {
        draft.purchasesSuppliersByMonthError = action.payload;
        draft.isLoading = false;
      });
    }
    case GET_PURCHASES_SUPPLIERS_BY_MONTH_EMPTY: {
      return produce(state, draft => {
        draft.purchasesSuppliersByMonth = null;
        draft.purchasesSuppliers = null;
      });
    }

    default: {
      return state;
    }
  }
};

export default gstrAnalysisReducer;
